// extracted by mini-css-extract-plugin
export default {"container":"Kuda_container__vHD+0","main":"Kuda_main__Xu4DR","body":"Kuda_body__FcL1E"};